import { CustomerOtherDebtType } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const otherDebtTypeMessages = defineMessages({
  creditCard: {
    defaultMessage: 'Credit card',
    description: 'other debt type title',
  },
  friendsFamily: {
    defaultMessage: 'Friends / family',
    description: 'other debt type title',
  },
  informalLender: {
    defaultMessage: 'Informal lender',
    description: 'other debt type title',
  },
  koperasi: {
    defaultMessage: 'Koperasi',
    description: 'other debt type title',
  },
  leasing: {
    defaultMessage: 'Leasing / multifinance',
    description: 'other debt type title',
  },
  other: {
    defaultMessage: 'Other',
    description: 'other debt type title',
  },
  paylater: {
    defaultMessage: 'Paylater',
    description: 'other debt type title',
  },
  pegadaian: {
    defaultMessage: 'Pegadaian',
    description: 'other debt type title',
  },
})

/**
 * "Koperasi, Other (arisan keluarga)" — the selected types joined, with the
 * free-text detail behind OTHER when one is on file.
 */
export function formatOtherDebtTypes(
  intl: IntlShape,
  debtTypes: readonly CustomerOtherDebtType[],
  otherDetail: string | null | undefined,
): string {
  return debtTypes
    .map((debtType) => {
      const label = translateOtherDebtType(intl, debtType)
      return debtType === CustomerOtherDebtType.OTHER && otherDetail
        ? `${label} (${otherDetail})`
        : label
    })
    .join(', ')
}

export function translateOtherDebtType(intl: IntlShape, debtType: CustomerOtherDebtType): string {
  switch (debtType) {
    case CustomerOtherDebtType.CREDIT_CARD:
      return intl.formatMessage(otherDebtTypeMessages.creditCard)
    case CustomerOtherDebtType.FRIENDS_FAMILY:
      return intl.formatMessage(otherDebtTypeMessages.friendsFamily)
    case CustomerOtherDebtType.INFORMAL_LENDER:
      return intl.formatMessage(otherDebtTypeMessages.informalLender)
    case CustomerOtherDebtType.KOPERASI:
      return intl.formatMessage(otherDebtTypeMessages.koperasi)
    case CustomerOtherDebtType.LEASING:
      return intl.formatMessage(otherDebtTypeMessages.leasing)
    case CustomerOtherDebtType.OTHER:
      return intl.formatMessage(otherDebtTypeMessages.other)
    case CustomerOtherDebtType.PAYLATER:
      return intl.formatMessage(otherDebtTypeMessages.paylater)
    case CustomerOtherDebtType.PEGADAIAN:
      return intl.formatMessage(otherDebtTypeMessages.pegadaian)
  }
}
